import http from '@/utils/request';

// 登录
export const login = (data = {}) => {
  const url = '/user/auth/loginByPassword';
  return http.post({
    url,
    data,
    appendApmPrefix: false,
  });
};

// 登出
export const logout = (data = {}) => {
  const url = '/user/auth/logout';
  return http.post({
    url,
    data,
    appendApmPrefix: false,
  });
};

// 修改密码
export const modifyPassword = (data = {}) => {
  const url = '/user/auth/editPassword';
  return http.post({
    url,
    data,
    appendApmPrefix: false,
  });
};
